// extracted by mini-css-extract-plugin
export default {"section":"home_section__3HB7P","container":"home_container__dQpbk","cols":"home_cols__206iQ","col":"home_col__3ObUl","notification":"home_notification__8Xxb3"};